import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_GIVEN_CANS } from "../given-cans.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateGivenCansInput } from "../../../__generated__/globalTypes";
import {
  CreateGivenCansMutation,
  CreateGivenCansMutationVariables,
} from "../../../__generated__/CreateGivenCansMutation";

interface IProps {
  defaultValues: DeepPartial<CreateGivenCansInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateGivenCans = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateGivenCansInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateGivenCansMutation,
    CreateGivenCansMutationVariables
  >(CREATE_GIVEN_CANS, {
    refetchQueries: ["GivenCansListQuery", "ProductQuery", "ProductsQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: {
            ...parseParams(input),
            comment: input.comment ?? "",
          },
        },
      });

      if (data?.createGivenCans?.ok) {
        onCompleted(data.createGivenCans.id);
      } else {
        throw Error(data?.createGivenCans?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
